export const VISITOR_CONTACT_COOKIE_NAME = 'VCR.ContactUser';
export const VISITOR_SESSION_COOKIE_NAME = 'VCR.SessionUser';

export const VISITOR_CONTACT_EXPIRATION_TIME: number = 94670778000;
export const VISITOR_SESSION_EXPIRATION_TIME: number = 1800000;
